import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [
  {
    navCap: 'Home',
  },
  {
    displayName: 'HOME',
    iconName: 'home',
    route: '/home',
  },
  {
    displayName: 'ANALYTICS',
    iconName: 'chart-bar',
    route: '/analytics',
  },
  {
    displayName: 'ORDERS',
    iconName: 'shopping-bag',
    route: '/orders',
  },
  {
    displayName: 'CLIENTS',
    iconName: 'users',
    route: '/clients',
  },
  {
    displayName: 'ORDER.MANUFACTURING.TITLE',
    iconName: 'list',
    route: '/manufacturing',
  },
  {
    displayName: 'FILLABLE_PDF',
    iconName: 'file-type-pdf',
    route: '/fillable-pdfs',
  },
  {
    displayName: 'CUSTOM_FORMS',
    iconName: 'forms',
    route: '/custom-forms',
  }
];
